import React, { useRef, useState } from "react"
import { Row, Col, Select, Typography, Avatar, Card } from "antd"
import moment from "moment"
import { useGetCryptoNewsQuery } from "../services/cryptoNewsApi"
import { useGetCryptosQuery } from "../services/cryptoApi"
import Loader from "./Loader"

{/* @ts-ignore */ }
const DexScreener = () => {
  const width = window.outerWidth
  const height = window.outerHeight

  return (
    <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: "100%",
    }}
  >
      <iframe
        src={'https://dexscreener.com?utm_source=soulswap'}
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          width: width,
          height: height,
          marginTop: -24,
        }}
      />
    </div>
  );
};

export default DexScreener;
